import React, { useState, useRef, useEffect } from "react";
import { FaBars } from "react-icons/fa";

const PGHeaderNavItems = ({ onHomeClick, onExamsClick, onContactClick, activeLink }) => {
  const [menuOpen, setMenuOpen] = useState(false);
   const headerInnerRef = useRef(null);
 
   useEffect(() => {
     if (!menuOpen) return undefined;
 
     const handleClickOutside = (event) => {
       if (!headerInnerRef.current?.contains(event.target)) {
         setMenuOpen(false);
       }
     };
 
     document.addEventListener("mousedown", handleClickOutside);
     document.addEventListener("touchstart", handleClickOutside);
 
     return () => {
       document.removeEventListener("mousedown", handleClickOutside);
       document.removeEventListener("touchstart", handleClickOutside);
     };
   }, [menuOpen]);
 
   const handleNavClick = (callback) => () => {
     setMenuOpen(false);
     callback?.();
   };
 
   return (
     <header className="header">
       <div ref={headerInnerRef} className="headerInner">
         <div className="logoWrapper">
           <img
             src="/EGTLogoExamHeaderCompressed.png"
             alt="eGRADTutor"
             className="LadingPageLogo"
           />
         </div>
 
         <nav className={`nav ${menuOpen ? "open" : ""}`} aria-label="Primary navigation">
         <button
   onClick={handleNavClick(onHomeClick)}
   className={`navLink ${activeLink === "home" ? "active" : ""}`}
 >
   Home
 </button>
 
 <button
   onClick={handleNavClick(onExamsClick)}
   className={`navLink ${activeLink === "exams" ? "active" : ""}`}
 >
   Exams
 </button>
 
 <button
   onClick={handleNavClick(onContactClick)}
   className={`navLink ${activeLink === "contact" ? "active" : ""}`}
 >
   Contact Us
 </button>
 <button
    className="navLink mockTestNav"
            type="button"
            onClick={() => {
              setMenuOpen(false);
              window.open("https://onlinepg.egradtutor.in/MockTest", "_blank");
            }}
          >
             <span className="newBadge"></span>
            Mock Test
          </button>
        
           <button
             className="mockBtn"
             type="button"
             onClick={() => {
               setMenuOpen(false);
               window.open("https://onlinepg.egradtutor.in/LoginPage", "_blank");
             }}
           >
             Login →
           </button>
         </nav>
 
         <button
           className="hamburger"
           onClick={() => setMenuOpen(!menuOpen)}
         >
           <FaBars />
         </button>
       </div>
     </header>
   );
 };

export default PGHeaderNavItems